export type CategoryTypes =
  | 'Conversations per month'
  | 'Creations'
  | 'AI Models'
  | 'Voice Features'
  | 'Settings'
  | 'Customization'
  | 'Automation Tools'
  | 'Analytics'
  | 'Summary';

export type FeaturesType = {
  name: string;
  category: CategoryTypes;
  valueType: 'string' | 'boolean';
  value?: string | boolean;
  inSummary?: boolean;
};

export interface IPlan {
  name: string;
  code: {
    monthly: { USD: string; EUR: string };
    annually: { USD: string; EUR: string };
  };
  price: {
    monthly: number | null;
    annually: number | null;
  };
  actionBtnText: string;
  features: FeaturesType[];
  isFeatured: boolean;
}

export enum EPlanCodes {
  FREE = 'CHATBOT_FREE',
  FREE_EU = 'CHABOTC_LSH3RKBR5W',
  BASIC_MONTHLY = 'CHATBOT_BASIC_MONTHLY',
  BASIC_MONTHLY_EU = 'CHABOM_YXN1LILRWY',
  BASIC_ANNUAL = 'CHATBOT_BASIC_ANNUAL',
  BASIC_ANNUAL_EU = 'CHABOA_02OW2E8C4U',
  BASIC_ANNUAL_TRIAL = 'CHATBOT_BASIC_ANNUAL_TRIAL',
  ADVANCED_MONTHLY = 'CHATBOT_ADVANCED_MONTHLY',
  ADVANCED_MONTHLY_EU = 'CHABOM_OSMFCYDT0V',
  ADVANCED_ANNUAL = 'CHATBOT_ADVANCED_ANNUAL',
  ADVANCED_ANNUAL_EU = 'CHABOA_B42CDBJP56',
  ADVANCED_ANNUAL_TRIAL = 'CHATBOT_ADVANCED_ANNUAL_TRIAL',
  ENTERPRISE_ANNUAL_EU = 'CHABOA_Y8O3FH61GW',
  ENTERPRISE_ANNUAL = 'CHABOM_5Q5FNDRELE',
  ENTERPRISE_MONTHLY_EU = 'CHABOM_TX5B3V1J9V',
  ENTERPRISE_MONTHLY = 'CHABOM_8F83AHUURU',
}
